import React from 'react';

function timeRemaining(endsAt) {
  const diff = new Date(endsAt) - new Date();
  if (diff <= 0) return 'Ended';
  const days = Math.floor(diff / 86400000);
  const hours = Math.floor((diff % 86400000) / 3600000);
  if (days > 0) return `${days}d ${hours}h remaining`;
  const mins = Math.floor((diff % 3600000) / 60000);
  return `${hours}h ${mins}m remaining`;
}

function formatDate(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

function formatScore(score) {
  const number = Number(score || 0);
  return number > 0 ? number.toFixed(1) : null;
}

export default function TakeoverCampaignCard({ campaign, onClick }) {
  const isActive = campaign.status === 'active';
  const isTargetComplete = campaign.completionReason === 'post_target_reached';
  const timeLeft = campaign.endsAt ? timeRemaining(campaign.endsAt) : '';
  const isEnded = isTargetComplete || !isActive || timeLeft === 'Ended';
  const topScore = formatScore(campaign.topScore);
  const acceptedPosts = campaign.postProgress?.acceptedPosts ?? campaign.participantCount ?? 0;
  const targetPosts = campaign.postProgress?.targetPosts ?? campaign.autoStop?.targetPosts;

  return (
    <div className="camp-card" onClick={onClick}>
      <div className="camp-left">
        <div className="camp-brand">{campaign.title}</div>
        <div className="camp-type">Timeline Takeover</div>
        <div className="camp-meta">
          <div className="camp-meta-item">
            <strong>{isEnded ? 'Ended:' : 'Deadline:'}</strong> {formatDate(campaign.endsAt)}
          </div>
          {targetPosts != null ? (
            <div className="camp-meta-item">
              <strong>Posts:</strong> {acceptedPosts} / {targetPosts}
            </div>
          ) : campaign.participantCount > 0 && (
            <div className="camp-meta-item">
              <strong>Creators:</strong> {campaign.participantCount}
            </div>
          )}
          {campaign.prizePool > 0 && (
            <div className="camp-meta-item">
              <strong>Prize:</strong> ${Number(campaign.prizePool).toLocaleString()} USDC
            </div>
          )}
          {topScore && (
            <div className="camp-meta-item">
              <strong>Top Score:</strong> {topScore}
            </div>
          )}
        </div>
      </div>
      <div className="camp-right">
        <div className={`camp-stage ${isEnded ? 'pending' : 'active'}`}>
          {isTargetComplete ? 'Campaign over' : isEnded ? 'Ended' : timeLeft}
        </div>
        {!isEnded && <div className="camp-arrow">&rarr;</div>}
      </div>
    </div>
  );
}
